import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/iletisim/page.tsx");
